module.exports = __webpack_public_path__ + "img/NoiseAware_Logo_Bug_Cream.361eac4b.svg";